import React from "react";
import LineSkeleton from "./LineSkeleton";

const UpdateFundedSkeleton = () => {
  return (
    <>
      {[1, 2].map((item) => (
        <div className="row mb-2" key={item}>
          <div className="col-sm-4">
            <div className="input-title">
              <LineSkeleton width="100px" height="20px" />
            </div>
          </div>
          <div className="col-sm-8">
            <LineSkeleton width="100%" height="45px" />
          </div>
        </div>
      ))}
      <div className="row mt-4">
        <div className="col-sm-12 d-flex justify-content-end">
          <LineSkeleton width="100px" height="40px" />
        </div>
      </div>
    </>
  );
};

export default UpdateFundedSkeleton;
